// src/Preloader.js
import React,{useState,useEffect} from 'react';
import icon from "../assets/images/icona.png";

const Preloader = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 300);
  }, []);

  return (<>
    { active ? (<div className="preloader">
      <img src={icon} alt="Loading..." className="rotating-image" />
    </div>) : (<div></div>)
    }</>
  );
};

export default Preloader;
